import { scriptRunner } from './domLoaded'
import { SSO_USER } from './user'

const UUID_CHANGE_EVENT = 'uuidChange'
const UUID_ELEMENT = '#user-uuid'

class UuidManager {
  private _uuid!: string

  constructor(uuid?: string) {
    this.uuid = uuid || createUUID()
    this.setup()
  }

  private setup() {
    scriptRunner(() => {
      this.uuid = this.getFromInputValue() || this._uuid
    })
  }

  private dispatchChange() {
    const event = new CustomEvent(UUID_CHANGE_EVENT, { detail: this._uuid })

    document.dispatchEvent(event)
  }

  private getFromInputValue() {
    return document.querySelector<HTMLInputElement>(UUID_ELEMENT)?.value
  }

  get(): string {
    return this._uuid
  }

  onChange(fn: (event) => void) {
    document.addEventListener(UUID_CHANGE_EVENT, fn)
  }

  set uuid(value: string) {
    if (this._uuid === value) return

    this._uuid = value
    this.dispatchChange()
  }
}

const attachUuidToForm = () => {
  // Avoids re-attachment on the password reset form.
  if (new URLSearchParams(location.search).has('pswdrst')) return

  const input = document.querySelector<HTMLInputElement>(UUID_ELEMENT)
  if (input) input.value = SSO_USER.get('uuid')
}

const createUUID = () => (
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
)

export { attachUuidToForm, createUUID, UuidManager }